module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.sizeClasses
  }, [(_vm.$slots.prepend || _vm.prepend) ? _c('div', {
    ref: "prependDiv",
    staticClass: "input-group-prepend"
  }, [_vm._t("prepend", [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(_vm._s(_vm.prepend))])])], 2) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "input",
    class: ("form-control " + _vm.inputClass),
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder,
      "aria-label": _vm.placeholder,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.inputValue
    },
    on: {
      "focus": function($event) {
        _vm.isFocused = true
      },
      "blur": _vm.handleBlur,
      "input": function($event) {
        _vm.handleInput($event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.$slots.append || _vm.append) ? _c('div', {
    staticClass: "input-group-append"
  }, [_vm._t("append", [_c('span', {
    staticClass: "input-group-text"
  }, [_vm._v(_vm._s(_vm.append))])])], 2) : _vm._e()]), _vm._v(" "), _c('vue-bootstrap-typeahead-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isFocused && _vm.data.length > 0),
      expression: "isFocused && data.length > 0"
    }],
    ref: "list",
    staticClass: "vbt-autcomplete-list",
    attrs: {
      "query": _vm.inputValue,
      "data": _vm.formattedData,
      "background-variant": _vm.backgroundVariant,
      "text-variant": _vm.textVariant,
      "maxMatches": _vm.maxMatches,
      "minMatchingChars": _vm.minMatchingChars
    },
    on: {
      "hit": _vm.handleHit
    }
  }, [_vm._l((_vm.$scopedSlots), function(slot, slotName) {
    return _c('template', {
      attrs: {
        "slot-scope": "{ data, htmlText }"
      },
      slot: slotName
    }, [_vm._t(slotName, null, null, {
      data: _vm.data,
      htmlText: _vm.htmlText
    })], 2)
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b2ea7324"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-bootstrap-typeahead/src/components/VueBootstrapTypeahead.vue
// module id = 1161
// module chunks = 5